import { styled } from '@mui/material/styles';

import { AppBar } from 'shared/components/AppBar';

export const AppBarWrapper = styled(AppBar)(({ theme }) => ({
  backgroundColor: 'transparent',
  paddingTop: theme.spacing(2),
  paddingInline: theme.spacing(4),
}));
